import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'lucide-react';

import { Button } from './';

interface InviteLinkButtonProps {
  icon?: React.ReactNode;
  onClick: () => void;
}

export function InviteLinkButton({ icon, onClick }: InviteLinkButtonProps) {
  const { t } = useTranslation();

  return (
    <Button className="flex shrink-0 items-center justify-center gap-1" onClick={onClick}>
      {t('invite_link_button.link')}
      {icon || <Link size="18" />}
    </Button>
  );
}
